import { TreasuryOverviewTypeEnum } from '@up/data';

export class TreasuryFullModuleOverviewPaymentSource {
  source: string;
  totalAmount?: number;
  totalRecords?: number;
}

export class TreasuryFullModuleOverviewType {
  type: TreasuryOverviewTypeEnum;
  fromDate: Date | string;
  toDate: Date | string;
  totalAmount?: number;
  totalRecords?: number;
  paymentSources: TreasuryFullModuleOverviewPaymentSource[];
}

export class TreasuryFullModuleOverviewResponseDto {
  businessEntityId: number;
  types: TreasuryFullModuleOverviewType[];
}
